import useFeatureFlags from '@cobliteam/hooks/src/useFeatureFlags';
import Icon from '@cobliteam/ui/icons';

const AlertIcon = ({ className, size = 'sm' }: { className?: string; size?: 'xs' | 'sm' | 'md' | 'lg' }) => {
  const featureFlags = useFeatureFlags();
  if (!featureFlags.alertBoletos) return null;

  const sizeClass = {
    xs: 'size-4',
    sm: 'size-5',
    md: 'size-6',
    lg: 'size-7',
  };
  return (
    <div className={className}>
      <span className={`relative flex ${sizeClass[size]}`}>
        <span className='absolute inline-flex h-full w-full animate-ping rounded-full bg-danger-5 opacity-75' />
        <span className={`relative inline-flex ${sizeClass[size]} items-center justify-center rounded-full bg-danger-5`}>
          <Icon name='circle-alert' size='sm' className='text-danger-11' />
        </span>
      </span>
    </div>
  );
};
export default AlertIcon;
